//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data: () => ({
		logged: false,
		wp_url: process.env.WP_BASE_URL
	}),
};
